import { createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({

    searchContainer: {
        flexGrow: 1,
        padding: `0 ${theme.spacing.unit / 2}px`,
        display: 'flex',
        alignItems: 'stretch',
        height: 26,
    },

    searchInput: {
        flexGrow: 1,
        fontSize: 14,
        '& input': {
            paddingRight: theme.spacing.unit * 2,
        },
    },

    searchButton: {
        position: 'absolute',
        top: 4,
        right: theme.spacing.unit / 2,
        fontSize: 18,
    },

});

export default style;
